import React from 'react';

import { SideNavContainer, SideNavbarLeft } from './styles.Navbar';
import { titles } from '../../data/titles';

type Props = {
  currentSection: string;
};

export const NavbarSide: React.FC<Props> = ({ currentSection }) => {
  return (
    <SideNavbarLeft>
      <SideNavContainer>
        {titles.map((title) => (
          <a
            key={title.id}
            href={`#${title.id}`}
            className={title.id === currentSection ? 'highlighted' : ''}
          >
            {title.name}
          </a>
        ))}
      </SideNavContainer>
    </SideNavbarLeft>
  );
};
